import { useEffect } from 'react'
import {
  LOGIN_FIELDS,
  SIGNUP_STEP_FIELDS,
  resolveLoginErrors,
  resolveSignupStepErrors,
  type CustomerAuthField,
  type CustomerAuthFieldErrorMap,
  type CustomerAuthValues,
} from './validation'

export const useCustomerAuthLiveValidation = ({
  isSignup,
  signupStep,
  values,
  touchedFields,
  dirtyFields,
  stepAttempted,
  submitted,
  setFieldErrorKeys,
}: {
  isSignup: boolean
  signupStep: number
  values: CustomerAuthValues
  touchedFields: Partial<Record<CustomerAuthField, boolean>>
  dirtyFields: Partial<Record<CustomerAuthField, boolean>>
  stepAttempted: boolean
  submitted: boolean
  setFieldErrorKeys: (next: CustomerAuthFieldErrorMap) => void
}) => {
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      const visibleFields = isSignup ? SIGNUP_STEP_FIELDS[signupStep] ?? [] : LOGIN_FIELDS
      const validation = isSignup ? resolveSignupStepErrors(signupStep, values) : resolveLoginErrors(values)
      const nextErrors: CustomerAuthFieldErrorMap = {}

      for (const field of visibleFields) {
        const message = validation[field]
        const showError =
          (Boolean(touchedFields[field]) && (Boolean(dirtyFields[field]) || stepAttempted)) || submitted
        if (!showError) continue
        if (message) nextErrors[field] = message
      }

      setFieldErrorKeys(nextErrors)
    }, 280)

    return () => window.clearTimeout(timeout)
  }, [dirtyFields, isSignup, setFieldErrorKeys, signupStep, stepAttempted, submitted, touchedFields, values])
}
